<template>
  <div class="flex flex-col gap-4">
    <div
      v-for="group in groups"
      :key="group.title"
      class="rounded-xl flex flex-col"
    >
      <div v-if="group.title" class="gray-block" @click="toggle(group.title)">
        <div class="flex items-center justify-center gap-2">
          <div
            class="justify-start text-foreground text-sm font-medium leading-6"
          >
            {{ group.title }}
          </div>
        </div>

        <svg-icon
          :name="expanded[group.title] ? 'huge-up' : 'huge-down'"
          class="w-5 h-5 ml-auto text-muted-foreground"
        />
      </div>

      <transition name="slide-fade">
        <div
          v-show="expanded[group.title]"
          :class="group.title ? 'pl-8 mt-3' : 'pl-4 mt-0'"
        >
          <ul class="flex flex-col gap-3">
            <li
              v-for="item in group.items"
              :key="item.code || item.name"
              class="flex items-center gap-4"
            >
              <div class="w-2 h-2 rounded-full dot"></div>
              <div
                v-if="typeof item === 'string'"
                class="justify-start text-muted-foreground text-sm font-normal leading-6"
              >
                {{ item }}
              </div>

              <span v-else class="text-muted-foreground">
                {{ item.name || item.label || item.code }}
              </span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewGroupList",

  props: {
    groups: {
      type: Array,
      required: true,
    },
    defaultExpanded: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      expanded: {},
    };
  },

  mounted() {
    this.groups.forEach((g) => {
      this.expanded[g.title] = this.defaultExpanded;
    });
  },

  methods: {
    toggle(key) {
      this.expanded[key] = !this.expanded[key];
    },
  },
};
</script>

<style scoped lang="scss">
.gray-block {
  @apply self-stretch px-4 py-3 rounded-xl inline-flex justify-between items-center cursor-pointer;
  background-color: hsl(var(--muted));
  border-radius: var(--radius);

  &:hover {
    background-color: hsl(var(--muted));
  }
}

.dot {
  background-color: hsl(var(--muted-foreground));
}
</style>
